// This JavaScript file is created by Cision for our printed material module.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.printedMaterial = function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = (cision.websolution.settings.printedMaterial || {}).accessKey,
        texts = cision.websolution.texts[settings.uiLanguage],
        itemsList = [],
        categories = [],
        firstRunList = true,
        firstRunArchiveList = true;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var renderItemList = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!accessKey) {
            console.log("You must provide your printed material access key.");
            return;
        }

        var d = $.Deferred();
        var url = generateUrl('PrintedMaterial/' + accessKey);

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCode: settings.uiLanguage,
                pageIndex: settings.PageIndex,
                pageSize: settings.PageSize || 50,
                startDate: settings.startDate,
                endDate: settings.endDate,
                category: settings.printedMaterialCategory
            }
        })
            .done(function (rawData) {
                $.each(rawData.Items, function (idx, objItem) {
                    objItem.PrintTimeFormatted = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objItem.PrintTimeFormattedDate = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.dateFormat);
                    objItem.PrintTimeFormattedTime = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.timeFormat);
                    objItem.MaxOrder = settings.maxAmountOfItems;

                    if (objItem.LogoUrl > 0) {
                        objItem.HasImage = true;
                    } else {
                        objItem.HasImage = false;
                    }

                    objItem.PublishTimeFormatted = moment(objItem.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objItem.ArchiveTimeFormatted = moment(objItem.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);

                    if (firstRunList && objItem.CategoryName) {
                        categories.push(objItem.CategoryName);
                    }

                });

                categories = _.uniq(categories);

                var compositeModel = $.extend(rawData, texts, settings);

                var tplElement = '#' + (settings.printedMaterialTemplateElement || 'tplPrintedMaterialItemListing');
                var renderedHtml = $(tplElement).render(compositeModel, cision.websolution.formatHelpers);

                if (firstRunList) {
                    texts.Categories = categories;
                    var renderedCategories = $("#tplCategories").render(texts);
                    $("#target-categories-2").html(renderedCategories);

                }

                var tplTarget = '#' + (settings.printedMaterialOutputTargetElement || 'itemListTarget');
                $(tplTarget).html(renderedHtml);

                firstRunList = false;

                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve active printed material data');
                d.reject();
            });
        return d.promise();
    };

    var renderArchiveList = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!accessKey) {
            console.log("You must provide your printed material access key.");
            return;
        }
        var url = generateUrl('PrintedMaterial/' + accessKey + '/Archive');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCode: settings.uiLanguage,
                pageIndex: settings.PageIndex,
                pageSize: settings.PageSize || 50,
                startDate: settings.startDate,
                endDate: settings.endDate,
                category: settings.printedMaterialCategory
            }
        })
            .done(function (rawData) {
                $.each(rawData.Items, function (idx, objItem) {
                    objItem.PrintTimeFormatted = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objItem.PrintTimeFormattedDate = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.dateFormat);
                    objItem.PrintTimeFormattedTime = moment(objItem.PrintTime).locale(settings.uiLanguage).format(settings.timeFormat);

                    objItem.PublishTimeFormatted = moment(objItem.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objItem.ArchiveTimeFormatted = moment(objItem.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);

                    if (firstRunArchiveList && objItem.Categories) {
                        $.each(objItem.Categories, function (idx2, objCategory) {
                            categories.push(objCategory);
                        });
                    }
                    itemsList[objItem.ItemGuid] = objItem;
                });

                categories = _.uniq(categories);

                var compositeModel = $.extend(rawData, texts, settings);

                var tplElement = '#' + (settings.printedMaterialTemplateElement || 'tplPrintedMaterialArchiveListing');
                var renderedHtml = $(tplElement).render(compositeModel, cision.websolution.formatHelpers);

                if (firstRunArchiveList) {
                    var renderedCategories = $("#tplCategories").render({ categories: categories });
                    $("#target-categories").html(renderedCategories);
                }

                var tplTarget = '#' + (settings.printedMaterialOutputTargetElement || 'archiveItemListTarget');
                $(tplTarget).html(renderedHtml);

                firstRunArchiveList = false;

            })
            .fail(function () {
                console.log('Could not retrieve archived printed material data');
            });
    };

    var getItemByGuid = function (options) {

        var itemGuid = options.itemGuid;
        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!itemGuid) {
            console.log("You must provide an item guid.");
            return;
        }
        var url = generateUrl('PrintedMaterial/' + accessKey + '/ItemDetail?itemguid=' + itemGuid);

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
        })
        .done(function (objResponse) {
            objResponse.PrintDateFormatted = moment(objResponse.PrintDate).locale(settings.uiLanguage).format(settings.dateFormatPrinted);

            var compositeModel = $.extend({}, objResponse, texts, settings),
                renderedHtml = $("#tplItemDetail").render(compositeModel, cision.websolution.formatHelpers);

            $("#target-item-detail").html(renderedHtml);

        })
            .fail(function () {
                console.log('Could not retrieve detailed data about the item');
            });
    };

    return {
        getItemByGuid: getItemByGuid,
        renderItemList: renderItemList,
        renderArchiveList: renderArchiveList
    };
}(jQuery);
